import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";

export default function WelcomeToDataPulseModal(props) {
  console.log(props);

  const [isModalVisible, setIsModalVisible] = useState(props.show || false);

  const hideModal = () => setIsModalVisible(false);

  return (
    <>
      <Modal show={isModalVisible} onHide={hideModal} className="welcome-to-datapulse-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>Welcome to DataPulse</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4">
            <p className="mb-2"><b>You're almost there!</b></p>
            <p className="mb-2" style={{paddingLeft: "8px"}}>Get started by creating an organization (or joining one if you have an invite code).</p>
            <p className="mb-4" style={{paddingLeft: "8px"}}>Once you're in, you can create your first account and start pulling in your data.</p>
            <div className="datapulse-layout-image">
              <img src={`/datapulse${require("images/lite/datapulse-layout.webp")}`} alt="DataPulse Layout" />
            </div>
          </div>

          <div className="welcome-to-datapulse-buttons">
            <button type="button" className="button b-type-primary b-size-normal b-color-green welcome-to-datapulse-button" onClick={hideModal}>
              Get Started
              <img className="filter-white" src={`/datapulse${require("images/lite/icons/chevron-right.svg")}`} alt="Get Started Icon" />
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
